'use client';
import React from 'react';

import { useLocale } from 'next-intl';

import { SearchResultsContext } from './SearchResultsContext';
import { loadMoreSearchResults as loadMore } from '../actions/loadMoreSearchResults';

const SearchResultsContextProvider = ({
  children,
  initialSearchResults,
  searchExpression,
}) => {
  const [searchResults, setSearchResults] = React.useState(
    initialSearchResults || []
  );
  const [activeFilters, setFilters] = React.useState<{ tags: string[] }>({
    tags: [],
  });
  const [chunksLoaded, setChunksLoaded] = React.useState(1);
  const locale = useLocale();
  const [isLoadingMoreResults, setIsLoadingMoreResults] = React.useState(false);
  const [noMoreResults, setNoMoreResults] = React.useState(false);

  const toggleFilters = React.useCallback(
    tags => {
      const filters = activeFilters.tags;

      tags.forEach(tag => {
        if (filters.includes(tag)) {
          filters.splice(filters.indexOf(tag), 1);
        } else {
          filters.push(tag);
        }
      });

      setFilters({
        tags: filters,
      });
    },
    [activeFilters]
  );

  React.useEffect(() => {
    setNoMoreResults(false);
    setChunksLoaded(1);
  }, [initialSearchResults, searchExpression, JSON.stringify(activeFilters)]);

  const loadMoreSearchResults = React.useCallback(
    () =>
      loadMore({
        setIsLoadingMoreResults,
        setChunksLoaded,
        searchResults,
        setSearchResults,
        chunksLoaded,
        locale,
        searchExpression,
        activeFilters,
        setNoMoreResults,
      }),
    [chunksLoaded, locale, searchExpression, searchResults]
  );

  return (
    <SearchResultsContext.Provider
      value={{
        activeFilters,
        toggleFilters,
        loadMoreSearchResults,
        searchResults,
        isLoadingMoreResults,
        noMoreResults,
      }}
    >
      {children}
    </SearchResultsContext.Provider>
  );
};

export { SearchResultsContext, SearchResultsContextProvider };
